export default {
  state:{
   resultName:""
  },
  mutations:{
    setResultName(state, name) {
      state.resultName=name
    }
  }
}
